import React from 'react'
import PropTypes from 'prop-types'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDatePicker,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalHeader,
  CRow,
  CCardFooter,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCamera, cilPencil, cilPlus, cilTrash } from '@coreui/icons'
import avatar1 from '../../../assets/images/avtar.png'
import avatar2 from '../../../assets/images/avatar-female.png'
import { useState, useEffect, useRef } from 'react'
import AppLoader from 'src/components/AppLoader'
import { getAllStreams } from 'src/services/report-card-services/report-services'
import { getAllClasses } from 'src/services/fees/fees-services'
import { getAllSession } from 'src/services/certificates/certificates-services'
import {
  getBanks,
  getBloodGroups,
  getDiscountBySession,
  getHouses,
  getLocalities,
  getMaritialStatus,
  getMotherTongues,
  getOccupations,
  getOtherCategories,
  getRelations,
  getReligions,
  getSchoolBoards,
  getSectionsByClass,
  getSocialCategories,
} from 'src/services/common-services'
import {
  confirmAdmission,
  editNewStudentEntry,
  getAdmissionDetailsById,
  getOnlineStudentDetailsById,
  submitStudentAdmission,
} from 'src/services/student/student-services'
import { getAllsubjectListTable } from 'src/services/master-settings/masterSettingsServices'
import Swal from 'sweetalert2'
import ConfirmAdmission from './ConfirmAdmission'
import { useLocation } from 'react-router-dom'

export default function StudentAdmission({ selectedAdmissionId }) {
  const [modalVisible, setModalVisible] = useState(false)

  const [studentPhoto, setStudentPhoto] = useState(null)
  const [fatherPhoto, setFatherPhoto] = useState(null)
  const [motherPhoto, setMotherPhoto] = useState(null)
  const [othersPhoto, setOthersPhoto] = useState(null)

  const [hasSibling, setHasSibling] = useState(false)
  const [hasGuardian, setHasGuardian] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [validated, setValidated] = useState(false)

  const [currSession, setCurrSession] = useState('')
  const [allSessions, setAllSessions] = useState([])
  const [allClasses, setAllClasses] = useState([])
  const [allSections, setAllSections] = useState([])
  const [allStreams, setAllStreams] = useState([])
  const [allSubjects, setAllSubjects] = useState([])
  const [allBloodGroup, setAllBloodGroup] = useState([])
  const [allLanguage, setAllLanguage] = useState([])
  const [allReligion, setAllReligion] = useState([])
  const [allSocialCategory, setAllSocialCategory] = useState([])
  const [allDiscounts, setAllDiscounts] = useState([])
  const [allLocality, setAllLocality] = useState([])
  const [allOtherCategory, setAllOtherCategory] = useState([])
  const [allHouses, setAllHouses] = useState([])
  const [allOccupations, setAllOccupations] = useState([])
  const [allSchoolBoards, setAllSchoolBoards] = useState([])
  const [allRelations, setAllRelations] = useState([])
  const [allMaritialStatus, setAllMaritialStatus] = useState([])
  const [allBanks, setAllBanks] = useState([])

  const [checkedSubjects, setCheckedSubjects] = useState([])
  const [mode, setMode] = useState('create')

  const defaultEntry = {
    qualExamName: '',
    qualSchClgName: '',
    qualBoardUniName: '',
    qualUniRegNo: '',
    qualSubjects: '',
    qualSession: '',
    qualPassYear: '',
    qualRollNo: '',
    qualMarksObt: '',
    qualDivClass: '',
    qualPercentage: '',
  }

  const [qualEntries, setQualEntries] = useState([defaultEntry])

  // const [selectedstudentDetails, selectedsetstudentDetails] = useState([])
  const [reponseAdmissionId, setReponseAdmissionId] = useState(null)

  const initialFormData = {
    // admissionId: '',
    // isAdmitted: '',
    sameAddress: false,
    session: '',
    dateOfAdmission: new Date(),
    studentFirstName: '',
    studentMiddleName: '',
    studentLastName: '',
    studclassToApply: '',
    studentGender: '',
    studentDOB: '',
    studentAge: '',
    studentSocialCat: '',
    studLocality: '',
    studMotherTongue: '',
    studReligion: '',
    studNationality: '',
    studBloodGroup: '',
    studAdharCardNo: '',
    studPrevSchoolName: '',
    studMoI: '',
    studBoard: '',
    studClass: '',
    commAddress: '',
    commCountry: 'India',
    commState: '',
    commCityDist: '',
    commPinCode: '',
    commContactNo: '',
    raAddress: '',
    raCountry: '',
    raState: '',
    raCityDist: '',
    raPinCode: '',
    raContactNo: '',
    sibling1StudId: '',
    sibling1Class: '',
    sibling1Section: '',
    sibling1RollNo: '',
    sibling2StudId: '',
    sibling2Class: '',
    sibling2Section: '',
    sibling2RollNo: '',
    fatherName: '',
    fatherOccupation: '',
    fatherContactNo: '',
    fatherAnnualIncome: '',
    fatherAdharCardNo: '',
    motherName: '',
    motherContactNo: '',
    motherAdharCardNo: '',
    otherType: '',
    othersAddress: '',
    othersName: '',
    othersRelation: '',
    othersMobileNo: '',
    studSmsContactNo: '',
    studEmailAddress: '',
    studStream: '',
    // loginId: '',
    studDiscCat: '',
    studentHouse: '',
    gardianBankName: '',
    bankBranchName: '',
    accountNo: '',
    ifscCode: '',
    classSection: '',
    fatherQual: '',
    motherQual: '',
    otherCategory: '',
    motherOccupation: '',
    fatherAdd: '',
    fatherNationality: '',
    fatherOfficeAdd: '',
    fatherOfficeContact: '',
    motherAdd: '',
    motherNationality: '',
    motherOfficeAdd: '',
    motherOfficeContact: '',
    motherAnnualIncome: '',
    // subjectsOffer: '',
    transferCertificate: 'No',
    // dateOfTc: '',
    prevSchoolCbse: '',
    prevPercentage: '',
    prevResult: '',
    refApplicationNumber: '',
    studMaritalStatus: '',
  }

  const [formData, setFormData] = useState(initialFormData)

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const applicationId = searchParams.get('application_id')
  const modeFromUrl = searchParams.get('mode') || 'create'

  const getAllSessionList = async () => {
    try {
      const response = await getAllSession()
      setAllSessions(response.data.data)

      const sessionData = response.data.data.find((session) => session.Default_Selected)
      if (sessionData) {
        setFormData((prev) => ({
          ...prev,
          session: sessionData.Session,
        }))
        setCurrSession(sessionData.Session)
      }
    } catch (error) {
      console.log('Error while getting all sessions', error)
    }
  }

  let endYear = null
  if (currSession) {
    endYear = parseInt(currSession.split('-')[1], 10)
  }

  let yearOptions = []
  if (endYear) {
    for (let y = endYear; y >= endYear - 10; y--) {
      yearOptions.push(y)
    }
  }

  const getClasses = () => {
    getAllClasses()
      .then((res) => {
        if (res.data.status == '200') {
          setAllClasses(res.data.data)
        }
      })
      .catch((err) => {
        console.log('Error while getting all classes', err.message)
      })
  }

  const getSections = (classId) => {
    getSectionsByClass(classId)
      .then((res) => {
        if (res.data.status == '200') {
          setAllSections(res.data.data)
        }
      })
      .catch((err) => {
        console.log('Error while getting all sections', err.message)
      })
  }

  const getStreams = () => {
    getAllStreams()
      .then((res) => {
        if (res.data.status == '200') {
          setAllStreams(res.data.data)
        }
        if (res.data.data.length > 0) {
          setFormData((prev) => ({
            ...prev,
            stream: res.data.data[0].Stream_Id,
          }))
        }
      })
      .catch((err) => {
        console.log('Error while getting all report card streams', err.message)
      })
  }

  const getsubjects = (classId) => {
    getAllsubjectListTable(classId)
      .then((res) => {
        if (res.data.status == '200') {
          setAllSubjects(res.data.data)
        }
      })
      .catch((err) => {
        console.log('Error while getting subjects', err.message)
      })
  }

  const getDiscounts = (session) => {
    getDiscountBySession(session)
      .then((res) => {
        if (res.data.status == '200') {
          setAllDiscounts(res.data.data)
        }
      })
      .catch((err) => {
        console.log('Error while getting discounts', err.message)
      })
  }

  const onFormValueChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleCheckboxChange = (subject) => {
    setCheckedSubjects((prev) => {
      if (prev.find((s) => s.Subject_Id === subject.Subject_Id)) {
        return prev
          .filter((s) => s.Subject_Id !== subject.Subject_Id)
          .map((s, idx) => ({ ...s, priority: idx + 1 }))
      }

      return [...prev, { ...subject, priority: prev.length + 1 }]
    })
  }

  const handleSameAddress = (isChecked) => {
    if (isChecked) {
      setFormData((prev) => ({
        ...prev,
        raAddress: prev.commAddress,
        raCityDist: prev.commCityDist,
        raState: prev.commState,
        raCountry: prev.commCountry,
        raPinCode: prev.commPinCode,
        raContactNo: prev.commContactNo,
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        raAddress: '',
        raCityDist: '',
        raState: '',
        raCountry: '',
        raPinCode: '',
        raContactNo: '',
      }))
    }
  }

  const handleAddEntry = () => {
    setQualEntries((prev) => [
      ...prev,
      {
        qualExamName: '',
        qualSchClgName: '',
        qualBoardUniName: '',
        qualUniRegNo: '',
        qualSubjects: '',
        qualSession: '',
        qualPassYear: '',
        qualRollNo: '',
        qualMarksObt: '',
        qualDivClass: '',
        qualPercentage: '',
      },
    ])
  }

  const handleRemoveEntry = (index) => {
    setQualEntries((prev) => prev.filter((_, i) => i !== index))
  }

  const handleEntryChange = (index, field, value) => {
    setQualEntries((prev) =>
      prev.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry)),
    )
  }

  const handleSubmit = (e, isEnroll = false) => {
    e.preventDefault()
    e.stopPropagation()

    const form = e.currentTarget
    if (!form.checkValidity()) {
      setValidated(true)
      return
    }

    setValidated(false)
    SaveStudentAdmission(isEnroll)
  }

  const SaveStudentAdmission = async (isEnroll = false) => {
    const studentDetailsJson = { ...formData }

    const methodSubjectsArray = checkedSubjects.map((s) => ({
      Subject_Id: s.Subject_Id,
      priority: s.priority,
    }))

    setIsLoading(true)
    try {
      let res

      if (mode === 'edit') {
        res = await editNewStudentEntry(
          studentDetailsJson,
          qualEntries,
          methodSubjectsArray,
          studentPhoto,
          fatherPhoto,
          motherPhoto,
          othersPhoto,
          selectedAdmissionId,
        )
      } else {
        const admitFields = mode === 'admit' ? { admissionSource: 'registerView' } : {}

        res = await submitStudentAdmission(
          studentDetailsJson,
          qualEntries,
          methodSubjectsArray,
          studentPhoto,
          fatherPhoto,
          motherPhoto,
          othersPhoto,
          admitFields,
        )
      }

      Swal.fire({
        icon: res.status == 200 ? 'success' : 'warning',
        text: res.message,
        timer: 2000,
        showConfirmButton: false,
      })

      if (res.status === 200) {
        const admissionId = res.data?.data?.admissionId

        if (admissionId) {
          setReponseAdmissionId(admissionId)
        }

        if (isEnroll && admissionId) {
          openEnrollModal(admissionId)
        }

        setFormData(initialFormData)
        setQualEntries([defaultEntry])
        setCheckedSubjects([])
        setStudentPhoto(null)
        setFatherPhoto(null)
        setMotherPhoto(null)
        setOthersPhoto(null)
      }
    } catch (err) {
      console.log('Error while Saving Admission:', err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const openEnrollModal = (admissionId) => {
    setReponseAdmissionId(admissionId)
    setModalVisible(true)
  }

  const handleEnroll = async (formValues) => {
    const { admissionId, studentId, sequenceNo, feeGroup, rollNo } = formValues
    try {
      const res = await confirmAdmission(
        admissionId,
        reponseAdmissionId,
        studentId,
        sequenceNo,
        feeGroup,
        rollNo,
      )
      if (res?.data?.status == 200) {
        Swal.fire({
          icon: 'success',
          text: res.data.message,
          timer: 2000,
          showConfirmButton: false,
        })
      } else {
        Swal.fire({
          icon: 'warning',
          text: res.data.message || 'Enrollment failed',
          timer: 2000,
          showConfirmButton: false,
        })
      }
    } catch (err) {
      Swal.fire({ icon: 'error', text: 'Enrollment failed', timer: 2000, showConfirmButton: false })
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const res1 = await getSocialCategories()
        setAllSocialCategory(res1?.data || [])

        const res3 = await getLocalities()
        setAllLocality(res3?.data || [])

        const res4 = await getBloodGroups()
        setAllBloodGroup(res4?.data || [])

        const res5 = await getMotherTongues()
        setAllLanguage(res5?.data || [])

        const res6 = await getReligions()
        setAllReligion(res6?.data || [])

        const res8 = await getOccupations()
        setAllOccupations(res8?.data || [])

        const res7 = await getOtherCategories()
        setAllOtherCategory(res7?.data || [])

        const res9 = await getHouses()
        setAllHouses(res9?.data || [])

        const res10 = await getSchoolBoards()
        setAllSchoolBoards(res10?.data || [])

        const res11 = await getBanks()
        setAllBanks(res11?.data || [])

        const res12 = await getRelations()
        setAllRelations(res12?.data || [])

        const res13 = await getMaritialStatus()
        setAllMaritialStatus(res13?.data.data || [])
      } catch (error) {
        console.error('Error fetching data: ', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    getAllSessionList()
  }, [])

  useEffect(() => {
    getAllSessionList()
    getClasses()
    getStreams()
  }, [])

  useEffect(() => {
    if (formData.session) {
      getDiscounts(formData.session)
    }
  }, [formData.session])

  useEffect(() => {
    if (!formData.studclassToApply) {
      setAllSections([])
      return
    }
    if (formData.studclassToApply) {
      getSections(formData.studclassToApply)
      getsubjects(formData.studclassToApply)
    }
  }, [formData.studclassToApply])

  useEffect(() => {
    const fetchDetails = async () => {
      if (selectedAdmissionId) {
        setIsLoading(true)
        try {
          const res = await getAdmissionDetailsById(selectedAdmissionId)
          if (res.data && res.data.data.length > 0) {
            setFormData(mapApiToFormData(res.data.data[0]))
          }
        } catch (err) {
          console.error('Error fetching student details:', err.message)
        } finally {
          setIsLoading(false)
        }
      } else {
        setFormData(initialFormData)
      }
    }

    fetchDetails()
  }, [selectedAdmissionId])

  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (applicationId) {
        setIsLoading(true)
        try {
          const res = await getOnlineStudentDetailsById(applicationId)
          if (res.data && res.data.data.length > 0) {
            setFormData(mapAdmitApiToFormData(res.data.data[0]))
          }
        } catch (err) {
          console.error('Error fetching student details:', err.message)
        } finally {
          setIsLoading(false)
        }
      } else {
        setFormData(initialFormData)
      }
    }

    fetchApplicationDetails()
  }, [applicationId])

  useEffect(() => {
    if (modeFromUrl) {
      setMode(modeFromUrl)
    } else if (selectedAdmissionId) {
      setMode('edit')
    } else {
      setMode('create')
    }
  }, [selectedAdmissionId, modeFromUrl])

  const mapApiToFormData = (apiData) => {
    return {
      isAdmitted: apiData.Is_Admited || '',
      admissionId: apiData.Admission_Id || '',
      sameAddress: false,
      session: apiData.Academic_Session || '',
      dateOfAdmission: apiData.Date_Of_Admission || '',
      studentFirstName: apiData.First_Name || '',
      studentMiddleName: apiData.Middle_Name || '',
      studentLastName: apiData.Last_Name || '',
      studclassToApply: apiData.Class_Id || '',
      studentGender: apiData.Gender || '',
      studentDOB: apiData.DOB || '',
      studentAge: apiData.Age || '',
      studentSocialCat: apiData.Social_Category || '',
      studLocality: apiData.Locality || '',
      studMotherTongue: apiData.Mother_Tongue || '',
      studReligion: apiData.Religion || '',
      studNationality: apiData.Nationality || '',
      studBloodGroup: apiData.Blood_Group || '',
      studAdharCardNo: apiData.Aadhar_No || '',
      studPrevSchoolName: apiData.Prev_School_Name || '',
      studMoI: apiData.Prev_School_Medium || '',
      studBoard: apiData.Prev_School_Board || '',
      studClass: apiData.Prev_School_Class || '',
      commAddress: apiData.Comm_Address || '',
      commCountry: apiData.Comm_Add_Country || 'India',
      commState: apiData.Comm_Add_State || '',
      commCityDist: apiData.Comm_Add_City_Dist || '',
      commPinCode: apiData.Comm_Add_Pincode || '',
      commContactNo: apiData.Comm_Add_ContactNo || '',
      raAddress: apiData.Resid_Address || '',
      raCountry: apiData.Resid_Add_Country || '',
      raState: apiData.Resid_Add_State || '',
      raCityDist: apiData.Resid_Add_City_Dist || '',
      raPinCode: apiData.Resid_Add_Pincode || '',
      raContactNo: apiData.Resid_Add_ContactNo || '',
      sibling1StudId: apiData.Sibling_1_Student_Id || '',
      sibling1Class: apiData.Sibling_1_Class || '',
      sibling1Section: apiData.Sibling_1_Section || '',
      sibling1RollNo: apiData.Sibling_1_RollNo || '',
      sibling2StudId: apiData.Sibling_2_Student_Id || '',
      sibling2Class: apiData.Sibling_2_Class || '',
      sibling2Section: apiData.Sibling_2_Section || '',
      sibling2RollNo: apiData.Sibling_2_RollNo || '',
      fatherName: apiData.Father_Name || '',
      fatherOccupation: apiData.Father_Occupation || '',
      fatherContactNo: apiData.Father_Contact_No || '',
      fatherAnnualIncome: apiData.Father_Annual_Income || '',
      fatherAdharCardNo: apiData.Father_Aadhar_Card || '',
      motherName: apiData.Mother_Name || '',
      motherContactNo: apiData.Mother_Contact_No || '',
      motherAdharCardNo: apiData.Mother_Aadhar_Card || '',
      otherType: apiData.Gurdian_Type || '',
      othersAddress: apiData.Guardian_Address || '',
      othersName: apiData.Guardian_Name || '',
      othersRelation: apiData.Guardian_Relation || '',
      othersMobileNo: apiData.Guardian_Contact_No || '',
      studSmsContactNo: apiData.SMS_Contact_No || '',
      studEmailAddress: apiData.Email_Id || '',
      studStream: apiData.Stream || '',
      studDiscCat: apiData.Discount_Category || '',
      studentHouse: apiData.Student_House || '',
      gardianBankName: apiData.Bank_Name || '',
      bankBranchName: apiData.Bank_Branch || '',
      accountNo: apiData.Account_No || '',
      ifscCode: apiData.IFSC_Code || '',
      classSection: apiData.Class_Sec_Id || '',
      fatherQual: apiData.Father_Qualification || '',
      motherQual: apiData.Mother_Qualification || '',
      otherCategory: apiData.Other_Category_Option || '',
      motherOccupation: apiData.Mother_Occupation || '',
      fatherAdd: apiData.Father_Address || '',
      fatherNationality: apiData.Father_Nationality || '',
      fatherOfficeAdd: apiData.Father_Org_Add || '',
      fatherOfficeContact: apiData.Father_Office_Contact || '',
      motherAdd: apiData.Mother_Address || '',
      motherNationality: apiData.Mother_Nationality || '',
      motherOfficeAdd: apiData.Mother_Org_Add || '',
      motherOfficeContact: apiData.Mother_Office_Contact || '',
      motherAnnualIncome: apiData.Mother_Annual_Income || '',
      transferCertificate: apiData.Transfer_Certificate || 'No',
      prevSchoolCbse: apiData.Prev_School_CBSE || '',
      prevPercentage: apiData.Prev_Percentage || '',
      prevResult: apiData.Prev_Result || '',
      refApplicationNumber: apiData.Reference_Application_No || '',
      studMaritalStatus: apiData.Marital_Status || '',
    }
  }

  const mapAdmitApiToFormData = (apiData) => {
    return {
      sameAddress: false,
      session: apiData.Session || '',
      dateOfAdmission: new Date(),
      studentFirstName: apiData.First_Name || '',
      studentMiddleName: apiData.Middle_Name || '',
      studentLastName: apiData.Last_Name || '',
      studclassToApply: apiData.Class_Id || '',
      studentGender: apiData.Gender || '',
      studentDOB: apiData.DOB || '',
      studentAge: apiData.Age || '',
      studentSocialCat: apiData.Social_Category || '',
      studLocality: apiData.Locality || '',
      studMotherTongue: apiData.Mother_Tongue || '',
      studReligion: apiData.Religion || '',
      studNationality: apiData.Nationality || '',
      studBloodGroup: apiData.Blood_Group || '',
      studAdharCardNo: apiData.Aadhar_No || '',
      studPrevSchoolName: apiData.Prev_School_Name || '',
      studMoI: apiData.Prev_School_Medium || '',
      studBoard: apiData.Prev_School_Board || '',
      studClass: apiData.Prev_School_Class || '',
      commAddress: apiData.Comm_Address || '',
      commCountry: apiData.Comm_Add_Country || 'India',
      commState: apiData.Comm_Add_State || '',
      commCityDist: apiData.Comm_Add_City_Dist || '',
      commPinCode: apiData.Comm_Add_Pincode || '',
      commContactNo: apiData.Comm_Add_ContactNo || '',
      raAddress: apiData.Resid_Address || '',
      raCountry: apiData.Resid_Add_Country || '',
      raState: apiData.Resid_Add_State || '',
      raCityDist: apiData.Resid_Add_City_Dist || '',
      raPinCode: apiData.Resid_Add_Pincode || '',
      raContactNo: apiData.Resid_Add_ContactNo || '',
      sibling1StudId: apiData.Sibling_1_Student_Id || '',
      sibling1Class: apiData.Sibling_1_Class || '',
      sibling1Section: apiData.Sibling_1_Section || '',
      sibling1RollNo: apiData.Sibling_1_RollNo || '',
      sibling2StudId: apiData.Sibling_2_Student_Id || '',
      sibling2Class: apiData.Sibling_2_Class || '',
      sibling2Section: apiData.Sibling_2_Section || '',
      sibling2RollNo: apiData.Sibling_2_RollNo || '',
      fatherName: apiData.Father_Name || '',
      fatherOccupation: apiData.Father_Occupation || '',
      fatherContactNo: apiData.Father_Contact_No || '',
      fatherAnnualIncome: apiData.Father_Annual_Income || '',
      fatherAdharCardNo: apiData.Father_Aadhar_Card || '',
      motherName: apiData.Mother_Name || '',
      motherContactNo: apiData.Mother_Contact_No || '',
      motherAdharCardNo: apiData.Mother_Aadhar_Card || '',
      otherType: apiData.Gurdian_Type || '',
      othersAddress: apiData.Guardian_Address || '',
      othersName: apiData.Guardian_Name || '',
      othersRelation: apiData.Guardian_Relation || '',
      othersMobileNo: apiData.Guardian_Contact_No || '',
      studSmsContactNo: apiData.SMS_Contact_No || '',
      studEmailAddress: apiData.Email_Id || '',
      studStream: apiData.Stream || '',
      studDiscCat: apiData.Discount_Category || '',
      studentHouse: '', // not in response
      gardianBankName: '', // not in response
      bankBranchName: '', // not in response
      accountNo: '', // not in response
      ifscCode: '', // not in response
      classSection: '', // not in response
      fatherQual: apiData.Father_Qualification || '',
      motherQual: apiData.Mother_Qualification || '',
      otherCategory: '', // not in response
      motherOccupation: apiData.Mother_Occupation || '',
      fatherAdd: apiData.Father_Address || '',
      fatherNationality: apiData.Father_Nationality || '',
      fatherOfficeAdd: apiData.Father_Office_Address || '',
      fatherOfficeContact: apiData.Father_Office_Telephone || '',
      motherAdd: apiData.Mother_Address || '',
      motherNationality: apiData.Mother_Nationality || '',
      motherOfficeAdd: apiData.Mother_Office_Address || '',
      motherOfficeContact: apiData.Mother_Office_Telephone || '',
      motherAnnualIncome: apiData.Mother_Annual_Income || '',
      transferCertificate: 'No',
      prevSchoolCbse: apiData.Is_Last_Board_CBSE || '',
      prevPercentage: apiData.Prev_Percentage || '',
      prevResult: apiData.Prev_Result || '',
      refApplicationNumber: apiData.Admission_Id || '',
      studMaritalStatus: apiData.studMaritalStatus || '',
    }
  }

  return (
    <>
      <CCard className="mb-2">
        <CCardHeader>
          <b>Admission Form</b>
        </CCardHeader>
        <CForm onSubmit={handleSubmit} noValidate validated={validated}>
          <CCardBody>
            <CRow>
              <CCol md={4}>
                <CRow>
                  <CFormLabel htmlFor="studentFirstName" className="col-md-4">
                    First Name
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="studentFirstName"
                      value={formData.studentFirstName}
                      onChange={(e) => onFormValueChange('studentFirstName', e.target.value)}
                      required
                      feedbackInvalid="Please add First Name"
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentMiddleName" className="col-md-4">
                    Middle Name
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="studentMiddleName"
                      value={formData.studentMiddleName}
                      onChange={(e) => onFormValueChange('studentMiddleName', e.target.value)}
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentLastName" className="col-md-4">
                    Last Name
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="studentLastName"
                      value={formData.studentLastName}
                      onChange={(e) => onFormValueChange('studentLastName', e.target.value)}
                    />
                  </CCol>
                  <CFormLabel htmlFor="studStream" className="col-md-4">
                    Stream
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studStream"
                      value={formData.studStream}
                      onChange={(e) => onFormValueChange('studStream', e.target.value)}
                    >
                      {allStreams.map((stream) => (
                        <option key={stream.Stream_Id} value={stream.Stream_Id}>
                          {stream.Stream_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studclassToApply" className="col-md-4">
                    Class
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studclassToApply"
                      value={formData.studclassToApply}
                      onChange={(e) => onFormValueChange('studclassToApply', e.target.value)}
                      required
                      feedbackInvalid="Please select class"
                    >
                      <option value="">Select Class</option>
                      {allClasses.map((data, index) => (
                        <option key={index} value={data.Class_Id}>
                          {data.Class_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="classSection" className="col-md-4">
                    Section
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="classSection"
                      value={formData.classSection}
                      onChange={(e) => onFormValueChange('classSection', e.target.value)}
                      required
                      feedbackInvalid="Please select section"
                    >
                      {allSections.map((data, index) => (
                        <option key={index} value={data.Class_Sec_Id}>
                          {data.Section}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="refApplicationNumber" className="col-md-4">
                    Application No.
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="refApplicationNumber"
                      value={formData.refApplicationNumber}
                      onChange={(e) => onFormValueChange('refApplicationNumber', e.target.value)}
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentGender" className="col-md-4">
                    Gender
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      id="studentGender"
                      name="studentGender"
                      value={formData.studentGender}
                      onChange={(e) => onFormValueChange('studentGender', e.target.value)}
                      required
                    >
                      <option value="">--Select--</option>
                      <option value="MALE">Male</option>
                      <option value="FEMALE">Female</option>
                      <option value="OTHER">Others</option>
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="dateOfAdmission" className="col-md-4">
                    Date Of Admission
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CDatePicker
                      name="dateOfAdmission"
                      date={formData.dateOfAdmission}
                      onDateChange={(value) => onFormValueChange('dateOfAdmission', value)}
                      locale="en-gb"
                    />
                  </CCol>
                  <CFormLabel htmlFor="transferCertificate" className="col-md-4">
                    Whether the Transfer Certificate is Attached
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="transferCertificate"
                      value={formData.transferCertificate}
                      onChange={(e) => onFormValueChange('transferCertificate', e.target.value)}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCol>

              <CCol md={4}>
                <CRow>
                  <CFormLabel htmlFor="studentDOB" className="col-md-4">
                    Date Of Birth
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CDatePicker
                      name="studentDOB"
                      date={formData.studentDOB}
                      onDateChange={(value) => onFormValueChange('studentDOB', value)}
                      locale="en-gb"
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentAge" className="col-md-4">
                    Age
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="studentAge"
                      value={formData.studentAge}
                      onChange={(e) => onFormValueChange('studentAge', e.target.value)}
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentSocialCat" className="col-md-4">
                    Social Category
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studentSocialCat"
                      value={formData.studentSocialCat}
                      onChange={(e) => onFormValueChange('studentSocialCat', e.target.value)}
                    >
                      <option value="">--Select Category--</option>
                      {allSocialCategory.map((data, index) => (
                        <option key={index} value={data.SC_Name}>
                          {data.SC_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studAcademicSession" className="col-md-4">
                    Academic Session
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="session"
                      value={formData.session}
                      onChange={(e) => onFormValueChange('session', e.target.value)}
                      required
                      feedbackInvalid="Please select session"
                    >
                      <option value="">Select session</option>
                      {allSessions.map((session, idx) => (
                        <option key={idx} value={session.Session}>
                          {session.Session}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studDiscCat" className="col-md-4">
                    Concession
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studDiscCat"
                      value={formData.studDiscCat}
                      onChange={(e) => onFormValueChange('studDiscCat', e.target.value)}
                    >
                      <option value="">--Select--</option>
                      {allDiscounts.map((data, index) => (
                        <option key={index} value={data.Concession_Id}>
                          {data.Concession_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studLocality" className="col-md-4">
                    Locality
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studLocality"
                      value={formData.studLocality}
                      onChange={(e) => onFormValueChange('studLocality', e.target.value)}
                    >
                      <option value="">--Select--</option>
                      {allLocality.map((data, index) => (
                        <option key={index} value={data.locationid}>
                          {data.location_name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studMotherTongue" className="col-md-4">
                    Mother Tongue
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studMotherTongue"
                      value={formData.studMotherTongue}
                      onChange={(e) => onFormValueChange('studMotherTongue', e.target.value)}
                    >
                      <option>--Select--</option>
                      {allLanguage.map((data, index) => (
                        <option key={index} value={data.Language_Id}>
                          {data.Language_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studMaritalStatus" className="col-md-4">
                    Marital Status
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studMaritalStatus"
                      value={formData.studMaritalStatus}
                      onChange={(e) => onFormValueChange('studMaritalStatus', e.target.value)}
                    >
                      {/* replace with api call */}
                      <option>--Select--</option>
                      {allMaritialStatus.map((data, index) => (
                        <option key={index} value={data.MS_Value}>
                          {data.MS_Value}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="otherCategory" className="col-md-4">
                    Other Category
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="otherCategory"
                      value={formData.otherCategory}
                      onChange={(e) => onFormValueChange('otherCategory', e.target.value)}
                    >
                      <option value="0">--Select--</option>
                      {allOtherCategory.map((data, index) => (
                        <option key={index} value={data.O_Id}>
                          {data.Other_Category_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studReligion" className="col-md-4">
                    Religion
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect id="studReligion" name="studReligion">
                      <option value="">--Select--</option>
                      {allReligion.map((religion, index) => (
                        <option key={index} value={religion.religion_name}>
                          {religion.religion_name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCol>

              <CCol md={4}>
                <CRow>
                  <CFormLabel htmlFor="studNationality" className="col-md-4">
                    Nationality
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect id="studNationality" name="studNationality">
                      <option value="">--Select--</option>
                      <option value="INDIAN">Indian</option>
                      <option value="OTHERS">Others</option>
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studBloodGroup" className="col-md-4">
                    Blood Group
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studBloodGroup"
                      value={formData.studBloodGroup}
                      onChange={(e) => onFormValueChange('studBloodGroup', e.target.value)}
                    >
                      <option value="">--Select--</option>
                      {allBloodGroup.map((data, index) => (
                        <option key={index} value={data.BG_Id}>
                          {data.BG_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CFormLabel htmlFor="studAdharCardNo" className="col-md-4">
                    Aadhaar No
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormInput
                      type="text"
                      name="studAdharCardNo"
                      value={formData.studAdharCardNo}
                      onChange={(e) => onFormValueChange('studAdharCardNo', e.target.value)}
                      pattern="[0-9]{12}"
                      title="Aadhar number must be a 12-digit number"
                      maxLength={12}
                    />
                  </CCol>
                  <CFormLabel htmlFor="studentHouse" className="col-md-4">
                    Select House
                  </CFormLabel>
                  <CCol className="mb-2" md={8}>
                    <CFormSelect
                      name="studentHouse"
                      value={formData.studentHouse}
                      onChange={(e) => onFormValueChange('studentHouse', e.target.value)}
                    >
                      <option value="">--Select--</option>
                      {allHouses.map((data, index) => (
                        <option key={index} value={data.house_id}>
                          {data.house_name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol className="text-center mt-4">
                    <p>Upload Student Photo (JPEG Less Than 2MB)</p>
                    <img src={avatar1} alt="preview" width={100} />

                    <div className="mt-2 d-flex justify-content-center gap-2">
                      <CButton>
                        <CIcon icon={cilCamera} />
                        <input
                          type="file"
                          accept="image/jpeg"
                          hidden
                          name="studentPhoto"
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file && file.size <= 2 * 1024 * 1024) {
                              setStudentPhoto(file)
                              const reader = new FileReader()
                              reader.onloadend = () => {
                                onFormValueChange('studentPhotoPreview', reader.result)
                              }
                              reader.readAsDataURL(file)
                            } else {
                              alert('File must be JPEG and less than 2MB')
                            }
                          }}
                        />
                      </CButton>

                      <CButton
                        onClick={() => document.querySelector('input[name="studentPhoto"]').click()}
                      >
                        <CIcon icon={cilPencil} />
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CCol>

              <CCardHeader className="mt-3">
                <b>Parent&apos;s Details</b>
              </CCardHeader>
              <CCardBody>
                <h6 className="mb-3">Father&apos;s Details</h6>
                <CRow>
                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="fatherName" className="col-md-4">
                        Father Name
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherName"
                          name="fatherName"
                          value={formData.fatherName}
                          onChange={(e) => onFormValueChange('fatherName', e.target.value)}
                        />
                      </CCol>
                      <CFormLabel htmlFor="fatherOccupation" className="col-md-4">
                        Father Occupation
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormSelect
                          id="fatherOccupation"
                          name="fatherOccupation"
                          value={formData.fatherOccupation}
                          onChange={(e) => onFormValueChange('fatherOccupation', e.target.value)}
                        >
                          <option value="">Select Occupation</option>
                          {allOccupations.map((occupation, index) => (
                            <option key={index} value={occupation.Occup_Id}>
                              {occupation.Occup_Name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>

                      <CFormLabel htmlFor="fatherAnnualIncome" className="col-md-4">
                        Father Annual Income
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherAnnualIncome"
                          name="fatherAnnualIncome"
                          value={formData.fatherAnnualIncome}
                          onChange={(e) => onFormValueChange('fatherAnnualIncome', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="fatherAdd" className="col-md-4">
                        Father Address
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormTextarea
                          type="text"
                          id="fatherAdd"
                          name="fatherAdd"
                          value={formData.fatherAdd}
                          onChange={(e) => onFormValueChange('fatherAdd', e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="fatherNationality" className="col-md-4">
                        Father Nationality
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherNationality"
                          name="fatherNationality"
                          value={formData.fatherNationality}
                          onChange={(e) => onFormValueChange('fatherNationality', e.target.value)}
                        />
                      </CCol>
                      <CFormLabel htmlFor="fatherContactNo" className="col-md-4">
                        Father Contact No.
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherContactNo"
                          name="fatherContactNo"
                          value={formData.fatherContactNo}
                          onChange={(e) => onFormValueChange('fatherContactNo', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="fatherAdharCardNo" className="col-md-4">
                        Father Aadhaar No.
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherAdharCardNo"
                          name="fatherAdharCardNo"
                          value={formData.fatherAdharCardNo}
                          onChange={(e) => onFormValueChange('fatherAdharCardNo', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="fatherOfficeAdd" className="col-md-4">
                        Father Office Address
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormTextarea
                          type="text"
                          id="fatherOfficeAdd"
                          name="fatherOfficeAdd"
                          value={formData.fatherOfficeAdd}
                          onChange={(e) => onFormValueChange('fatherOfficeAdd', e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="fatherQual" className="col-md-4">
                        Father Qualification
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherQual"
                          name="fatherQual"
                          value={formData.fatherQual}
                          onChange={(e) => onFormValueChange('fatherQual', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="fatherOfficeContact" className="col-md-4">
                        Father Office Contact
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="fatherOfficeContact"
                          name="fatherOfficeContact"
                          value={formData.fatherOfficeContact}
                          onChange={(e) => onFormValueChange('fatherOfficeContact', e.target.value)}
                        />
                      </CCol>
                      <CCol className="text-center mt-4">
                        <p>Upload Father Photo (JPEG Less Than 2MB)</p>
                        <img src={avatar1} alt="preview" width={100} />

                        <div className="mt-2 d-flex justify-content-center gap-2">
                          <CButton>
                            <CIcon icon={cilCamera} />
                            <input
                              type="file"
                              accept="image/jpeg"
                              hidden
                              name="fatherPhoto"
                              onChange={(e) => {
                                const file = e.target.files[0]
                                if (file && file.size <= 2 * 1024 * 1024) {
                                  setFatherPhoto(file)
                                  const reader = new FileReader()
                                  reader.onloadend = () => {
                                    onFormValueChange('fatherPhotoPreview', reader.result)
                                  }
                                  reader.readAsDataURL(file)
                                } else {
                                  alert('File must be JPEG and less than 2MB')
                                }
                              }}
                            />
                          </CButton>

                          <CButton
                            onClick={() =>
                              document.querySelector('input[name="fatherPhoto"]').click()
                            }
                          >
                            <CIcon icon={cilPencil} />
                          </CButton>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <hr className="my-4" />

                <h6 className="mb-3">Mother&apos;s Details</h6>
                <CRow>
                  {/* Mother Column 1 */}
                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="motherName" className="col-md-4">
                        Mother Name
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherName"
                          name="motherName"
                          value={formData.motherName}
                          onChange={(e) => onFormValueChange('motherName', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherOccupation" className="col-md-4">
                        Mother Occupation
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormSelect
                          id="motherOccupation"
                          name="motherOccupation"
                          value={formData.motherOccupation}
                          onChange={(e) => onFormValueChange('motherOccupation', e.target.value)}
                        >
                          <option value="">Select Occupation</option>
                          {allOccupations.map((occupation, index) => (
                            <option key={index} value={occupation.Occup_Id}>
                              {occupation.Occup_Name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>

                      <CFormLabel htmlFor="motherAnnualIncome" className="col-md-4">
                        Mother Annual Income
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherAnnualIncome"
                          name="motherAnnualIncome"
                          value={formData.motherAnnualIncome}
                          onChange={(e) => onFormValueChange('motherAnnualIncome', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherAdd" className="col-md-4">
                        Mother Address
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormTextarea
                          type="text"
                          id="motherAdd"
                          name="motherAdd"
                          value={formData.motherAdd}
                          onChange={(e) => onFormValueChange('motherAdd', e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  {/* Mother Column 2 */}
                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="motherNationality" className="col-md-4">
                        Mother Nationality
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherNationality"
                          name="motherNationality"
                          value={formData.motherNationality}
                          onChange={(e) => onFormValueChange('motherNationality', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherContactNo" className="col-md-4">
                        Mother Contact No.
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherContactNo"
                          name="motherContactNo"
                          value={formData.motherContactNo}
                          onChange={(e) => onFormValueChange('motherContactNo', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherAdharCardNo" className="col-md-4">
                        Mother Aadhaar No.
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherAdharCardNo"
                          name="motherAdharCardNo"
                          value={formData.motherAdharCardNo}
                          onChange={(e) => onFormValueChange('motherAdharCardNo', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherOfficeAdd" className="col-md-4">
                        Mother Office Address
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormTextarea
                          type="text"
                          id="motherOfficeAdd"
                          name="motherOfficeAdd"
                          value={formData.motherOfficeAdd}
                          onChange={(e) => onFormValueChange('motherOfficeAdd', e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  {/* Mother Column 3 */}
                  <CCol md={4}>
                    <CRow>
                      <CFormLabel htmlFor="motherQual" className="col-md-4">
                        Mother Qualification
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherQual"
                          name="motherQual"
                          value={formData.motherQual}
                          onChange={(e) => onFormValueChange('motherQual', e.target.value)}
                        />
                      </CCol>

                      <CFormLabel htmlFor="motherOfficeContact" className="col-md-4">
                        Mother Office Contact
                      </CFormLabel>
                      <CCol md={8} className="mb-2">
                        <CFormInput
                          type="text"
                          id="motherOfficeContact"
                          name="motherOfficeContact"
                          value={formData.motherOfficeContact}
                          onChange={(e) => onFormValueChange('motherOfficeContact', e.target.value)}
                        />
                      </CCol>

                      {/* Mother Photo Upload */}
                      <CCol className="text-center mt-4">
                        <p>Upload Mother Photo (JPEG Less Than 2MB)</p>
                        <img src={avatar2} alt="mother" width={100} />

                        <div className="mt-2 d-flex justify-content-center gap-2">
                          <CButton>
                            <CIcon icon={cilCamera} />
                            <input
                              type="file"
                              accept="image/jpeg"
                              hidden
                              name="motherPhoto"
                              onChange={(e) => {
                                const file = e.target.files[0]
                                if (file && file.size <= 2 * 1024 * 1024) {
                                  setMotherPhoto(file)
                                  const reader = new FileReader()
                                  reader.onloadend = () => {
                                    onFormValueChange('motherPhotoPreview', reader.result)
                                  }
                                  reader.readAsDataURL(file)
                                } else {
                                  alert('File must be JPEG and less than 2MB')
                                }
                              }}
                            />
                          </CButton>

                          <CButton
                            onClick={() =>
                              document.querySelector('input[name="motherPhoto"]').click()
                            }
                          >
                            <CIcon icon={cilPencil} />
                          </CButton>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Method Subject</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  {/* Left side: checkboxes */}
                  <CCol md={6}>
                    <CFormLabel>Select :</CFormLabel>
                    <div
                      style={{
                        minHeight: '110px',
                        overflowY: 'auto',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                      }}
                      className="border rounded p-2 primary-bg"
                    >
                      {allSubjects.map((data, index) => (
                        <CFormCheck
                          key={index}
                          type="checkbox"
                          id={`subject-${index}`}
                          label={data.Subject_Name}
                          value={data.Subject_Id}
                          className="small-check-box"
                          checked={checkedSubjects.some((s) => s.Subject_Id === data.Subject_Id)}
                          onChange={() => handleCheckboxChange(data)}
                        />
                      ))}
                    </div>
                  </CCol>

                  {/* Right side: selected subjects with priority (row format) */}
                  <CCol md={6}>
                    <CFormLabel>Method Subject (with Priority)</CFormLabel>
                    <CFormTextarea
                      rows={4}
                      value={checkedSubjects
                        .map((s, idx) => `${idx + 1}. ${s.Subject_Name}`)
                        .join(', ')} // <-- row style
                      readOnly
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Previous School Details</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={3}>
                    <CFormLabel>School Name and Address</CFormLabel>
                    <CFormInput
                      type="text"
                      id="studPrevSchoolName"
                      name="studPrevSchoolName"
                      value={formData.studPrevSchoolName}
                      onChange={(e) => onFormValueChange('studPrevSchoolName', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Last School was CBSE affiliated</CFormLabel>
                    <CFormSelect
                      id="prevSchoolCbse"
                      name="prevSchoolCbse"
                      value={formData.prevSchoolCbse}
                      onChange={(e) => onFormValueChange('prevSchoolCbse', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No" selected>
                        No
                      </option>
                    </CFormSelect>
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Board</CFormLabel>
                    <CFormSelect
                      id="studBoard"
                      name="studBoard"
                      value={formData.studBoard}
                      onChange={(e) => onFormValueChange('studBoard', e.target.value)}
                    >
                      <option value="">Select Board</option>
                      {allSchoolBoards.map((data, index) => (
                        <option key={index} value={data.Board_Id}>
                          {data.Board_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Class</CFormLabel>
                    <CFormSelect
                      id="studClass"
                      name="studClass"
                      value={formData.studClass}
                      onChange={(e) => onFormValueChange('studClass', e.target.value)}
                    >
                      <option value="">Select Class</option>
                      {allClasses.map((data, index) => (
                        <option key={index} value={data.Class_Id}>
                          {data.Class_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={3}>
                    <CFormLabel>Medium of Instruction</CFormLabel>
                    <CFormSelect
                      id="studMoI"
                      name="studMoI"
                      value={formData.studMoI}
                      onChange={(e) => onFormValueChange('studMoI', e.target.value)}
                    >
                      <option value="">Select</option>
                      {allLanguage.map((data, index) => (
                        <option key={index} value={data.Language_Id}>
                          {data.Language_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Result of last examination</CFormLabel>
                    <CFormInput
                      type="text"
                      id="prevResult"
                      name="prevResult"
                      value={formData.prevResult}
                      onChange={(e) => onFormValueChange('prevResult', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Percentage</CFormLabel>
                    <CFormInput
                      type="text"
                      id="prevPercentage"
                      name="prevPercentage"
                      value={formData.prevPercentage}
                      onChange={(e) => onFormValueChange('prevPercentage', e.target.value)}
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Qualification Details</b>
              </CCardHeader>
              <CCardBody>
                {qualEntries.map((entry, index) => (
                  <div key={index} className="border rounded p-3 mb-3">
                    <CRow className="mb-3">
                      <CCol md={3}>
                        <CFormLabel>Exam Name</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualExamName}
                          onChange={(e) => handleEntryChange(index, 'qualExamName', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>College Name</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualSchClgName}
                          onChange={(e) =>
                            handleEntryChange(index, 'qualSchClgName', e.target.value)
                          }
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Board/University</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualBoardUniName}
                          onChange={(e) =>
                            handleEntryChange(index, 'qualBoardUniName', e.target.value)
                          }
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>University Reg No</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualUniRegNo}
                          onChange={(e) => handleEntryChange(index, 'qualUniRegNo', e.target.value)}
                        />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={3}>
                        <CFormLabel>Subjects</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualSubjects}
                          onChange={(e) => handleEntryChange(index, 'qualSubjects', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Session</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualSession}
                          onChange={(e) => handleEntryChange(index, 'qualSession', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Year of Passing</CFormLabel>
                        <CFormSelect
                          value={entry.qualPassYear}
                          onChange={(e) => handleEntryChange(index, 'qualPassYear', e.target.value)}
                        >
                          <option value="">Select Year</option>
                          {yearOptions.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Roll No</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualRollNo}
                          onChange={(e) => handleEntryChange(index, 'qualRollNo', e.target.value)}
                        />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={3}>
                        <CFormLabel>Marks Obtained</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualMarksObt}
                          onChange={(e) => handleEntryChange(index, 'qualMarksObt', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Div./Class</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualDivClass}
                          onChange={(e) => handleEntryChange(index, 'qualDivClass', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Percentage of Marks</CFormLabel>
                        <CFormInput
                          type="text"
                          value={entry.qualPercentage}
                          onChange={(e) =>
                            handleEntryChange(index, 'qualPercentage', e.target.value)
                          }
                        />
                      </CCol>
                      {qualEntries.length > 1 && (
                        <CCol md={3} className="d-flex justify-content-end align-items-end gap-2">
                          <CButton
                            color="danger"
                            className="text-white"
                            onClick={() => handleRemoveEntry(index)}
                          >
                            <CIcon icon={cilTrash} /> Delete
                          </CButton>
                        </CCol>
                      )}
                    </CRow>
                  </div>
                ))}

                <CButton
                  color="success"
                  className="text-white ms-auto d-flex align-items-center"
                  onClick={handleAddEntry}
                >
                  <CIcon icon={cilPlus} /> Add Qualification
                </CButton>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Communication Address</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>Communication Address</CFormLabel>
                    <CFormTextarea
                      rows={2}
                      id="commAddress"
                      name="commAddress"
                      value={formData.commAddress}
                      onChange={(e) => onFormValueChange('commAddress', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>City/ District</CFormLabel>
                    <CFormInput
                      type="text"
                      id="commCityDist"
                      name="commCityDist"
                      value={formData.commCityDist}
                      onChange={(e) => onFormValueChange('commCityDist', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>State</CFormLabel>
                    <CFormInput
                      type="text"
                      id="commState"
                      name="commState"
                      value={formData.commState}
                      onChange={(e) => onFormValueChange('commState', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Country</CFormLabel>
                    <CFormInput
                      type="text"
                      id="commCountry"
                      name="commCountry"
                      value={formData.commCountry || 'India'}
                      onChange={(e) => onFormValueChange('commCountry', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Pincode</CFormLabel>
                    <CFormInput
                      type="text"
                      id="commPinCode"
                      name="commPinCode"
                      value={formData.commPinCode}
                      onChange={(e) => onFormValueChange('commPinCode', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Contact No.</CFormLabel>
                    <CFormInput
                      type="text"
                      id="commContactNo"
                      name="commContactNo"
                      value={formData.commContactNo}
                      onChange={(e) => onFormValueChange('commContactNo', e.target.value)}
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4 ">
                <b>Residential Address</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-0">
                  <CCol md={12}>
                    <p className="me-2">
                      <i>Same As Communication Address</i>
                      <sup>
                        <CFormCheck
                          id="sameAddress"
                          style={{ transform: 'scale(0.5)', border: '1px solid black' }}
                          checked={formData.sameAddress || false}
                          onChange={(e) => {
                            const isChecked = e.target.checked
                            onFormValueChange('sameAddress', isChecked)
                            handleSameAddress(isChecked)
                          }}
                        />
                      </sup>
                    </p>
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>Residential Address</CFormLabel>
                    <CFormTextarea
                      rows={2}
                      id="raAddress"
                      name="raAddress"
                      value={formData.raAddress}
                      onChange={(e) => onFormValueChange('raAddress', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>City/ District</CFormLabel>
                    <CFormInput
                      type="text"
                      id="raCityDist"
                      name="raCityDist"
                      value={formData.raCityDist}
                      onChange={(e) => onFormValueChange('raCityDist', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>State</CFormLabel>
                    <CFormInput
                      type="text"
                      id="raState"
                      name="raState"
                      value={formData.raState}
                      onChange={(e) => onFormValueChange('raState', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Country</CFormLabel>
                    <CFormInput
                      type="text"
                      id="raCountry"
                      name="raCountry"
                      value={formData.raCountry || 'India'}
                      onChange={(e) => onFormValueChange('raCountry', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Pincode</CFormLabel>
                    <CFormInput
                      type="text"
                      id="raPinCode"
                      name="raPinCode"
                      value={formData.raPinCode}
                      onChange={(e) => onFormValueChange('raPinCode', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Contact No.</CFormLabel>
                    <CFormInput
                      type="text"
                      id="raContactNo"
                      name="raContactNo"
                      value={formData.raContactNo}
                      onChange={(e) => onFormValueChange('raContactNo', e.target.value)}
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3">
                <b>Sibling Details</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3 text-center">
                  <CCol md={12} className="text-center">
                    <CFormLabel>Any Sibling in this School? (Real brother/sister)</CFormLabel>
                    <div className="d-flex gap-4 mt-1 justify-content-center">
                      <CFormCheck
                        type="radio"
                        name="sibling"
                        id="siblingYes"
                        label="Yes"
                        checked={hasSibling === true}
                        onChange={() => setHasSibling(true)}
                      />
                      <CFormCheck
                        type="radio"
                        name="sibling"
                        id="siblingNo"
                        label="No"
                        checked={hasSibling === false}
                        defaultChecked
                        onChange={() => setHasSibling(false)}
                      />
                    </div>
                  </CCol>
                </CRow>

                {hasSibling && (
                  <>
                    {/* Sibling 1 */}
                    <CRow className="mb-3">
                      <CCol md={3}>
                        <CFormLabel>Student Id</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Student Id"
                          value={formData.sibling1StudId}
                          onChange={(e) => onFormValueChange('sibling1StudId', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Class</CFormLabel>
                        <CFormSelect
                          value={formData.sibling1Class}
                          onChange={(e) => onFormValueChange('sibling1Class', e.target.value)}
                        >
                          <option value="">Select Class</option>
                          {allClasses.map((data, index) => (
                            <option key={index} value={data.Class_Id}>
                              {data.Class_Name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Section</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Section"
                          value={formData.sibling1Section}
                          onChange={(e) => onFormValueChange('sibling1Section', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Roll No.</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Roll No."
                          value={formData.sibling1RollNo}
                          onChange={(e) => onFormValueChange('sibling1RollNo', e.target.value)}
                        />
                      </CCol>
                    </CRow>

                    {/* Sibling 2 */}
                    <CRow className="mb-3">
                      <CCol md={3}>
                        <CFormLabel>Student Id</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Student Id"
                          value={formData.sibling2StudId}
                          onChange={(e) => onFormValueChange('sibling2StudId', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Class</CFormLabel>
                        <CFormSelect
                          value={formData.sibling2Class}
                          onChange={(e) => onFormValueChange('sibling2Class', e.target.value)}
                        >
                          <option value="">Select Class</option>
                          {allClasses.map((data, index) => (
                            <option key={index} value={data.Class_Id}>
                              {data.Class_Name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Section</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Section"
                          value={formData.sibling2Section}
                          onChange={(e) => onFormValueChange('sibling2Section', e.target.value)}
                        />
                      </CCol>
                      <CCol md={3}>
                        <CFormLabel>Roll No.</CFormLabel>
                        <CFormInput
                          type="text"
                          placeholder="Enter Roll No."
                          value={formData.sibling2RollNo}
                          onChange={(e) => onFormValueChange('sibling2RollNo', e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </>
                )}
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Guardian Details</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={12}>
                    <div className="d-flex gap-4 justify-content-center">
                      <CFormCheck
                        type="radio"
                        name="guardian"
                        id="guardianFather"
                        label="Father"
                        checked={formData.otherType === 'Father'}
                        onChange={() => onFormValueChange('otherType', 'Father')}
                      />
                      <CFormCheck
                        type="radio"
                        name="guardian"
                        id="guardianMother"
                        label="Mother"
                        checked={formData.otherType === 'Mother'}
                        onChange={() => onFormValueChange('otherType', 'Mother')}
                      />
                      <CFormCheck
                        type="radio"
                        name="guardian"
                        id="guardianHostel"
                        label="If Hostel (Local Guardian)"
                        checked={formData.otherType === 'LocalGuardian'}
                        onChange={() => {
                          onFormValueChange('otherType', 'LocalGuardian')
                          setHasGuardian(true)
                        }}
                      />
                    </div>
                  </CCol>
                </CRow>

                {formData.otherType === 'LocalGuardian' && (
                  <CRow className="mb-3">
                    <CCol md={4}>
                      <CFormLabel>Guardian Address</CFormLabel>
                      <CFormTextarea
                        rows={4}
                        value={formData.othersAddress}
                        onChange={(e) => onFormValueChange('othersAddress', e.target.value)}
                      />
                    </CCol>

                    <CCol md={4}>
                      <CFormLabel>Guardian Name</CFormLabel>
                      <CFormInput
                        type="text"
                        className="mb-2"
                        value={formData.othersName}
                        onChange={(e) => onFormValueChange('othersName', e.target.value)}
                      />

                      <CFormLabel>Relation</CFormLabel>
                      <CFormSelect
                        className="mb-2"
                        value={formData.othersRelation}
                        onChange={(e) => onFormValueChange('othersRelation', e.target.value)}
                      >
                        <option value="">Select Relation</option>
                        {allRelations.map((relation, index) => (
                          <option key={index} value={relation.Relation_Id}>
                            {relation.Relation_Name}
                          </option>
                        ))}
                      </CFormSelect>

                      <CFormLabel>Mobile No.</CFormLabel>
                      <CFormInput
                        type="text"
                        value={formData.othersMobileNo}
                        onChange={(e) => onFormValueChange('othersMobileNo', e.target.value)}
                      />
                    </CCol>

                    <CCol md={4} className="text-center ">
                      <p>Upload Guardian Photo (JPEG Less Than 2MB)</p>
                      <img src={avatar1} alt="guardian" width={100} />

                      <div className="mt-2 d-flex justify-content-center gap-2">
                        <CButton>
                          <CIcon icon={cilCamera} />
                          <input
                            type="file"
                            accept="image/jpeg"
                            hidden
                            name="othersPhoto"
                            onChange={(e) => {
                              const file = e.target.files[0]
                              if (file && file.size <= 2 * 1024 * 1024) {
                                setOthersPhoto(file)
                                const reader = new FileReader()
                                reader.onloadend = () => {
                                  onFormValueChange('othersPhotoPreview', reader.result)
                                }
                                reader.readAsDataURL(file)
                              } else {
                                alert('File must be JPEG and less than 2MB')
                              }
                            }}
                          />
                        </CButton>

                        <CButton
                          onClick={() => document.querySelector('input[name="otherPhoto"]').click()}
                        >
                          <CIcon icon={cilPencil} />
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                )}
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>Guardian Bank Details</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={3}>
                    <CFormLabel>Select Bank</CFormLabel>
                    <CFormSelect
                      id="gardianBankName"
                      name="gardianBankName"
                      value={formData.gardianBankName}
                      onChange={(e) => onFormValueChange('gardianBankName', e.target.value)}
                    >
                      <option value="">Select Bank</option>
                      {allBanks.map((data, index) => (
                        <option key={index} value={data.Bank_Id}>
                          {data.Bank_Name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Branch Name</CFormLabel>
                    <CFormInput
                      type="text"
                      id="bankBranchName"
                      name="bankBranchName"
                      value={formData.bankBranchName}
                      onChange={(e) => onFormValueChange('bankBranchName', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>Account No</CFormLabel>
                    <CFormInput
                      type="text"
                      id="accountNo"
                      name="accountNo"
                      value={formData.accountNo}
                      onChange={(e) => onFormValueChange('accountNo', e.target.value)}
                    />
                  </CCol>

                  <CCol md={3}>
                    <CFormLabel>IFSC Code</CFormLabel>
                    <CFormInput
                      type="text"
                      id="ifscCode"
                      name="ifscCode"
                      value={formData.ifscCode}
                      onChange={(e) => onFormValueChange('ifscCode', e.target.value)}
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              <CCardHeader className="mb-3 mt-4">
                <b>SMS Communication</b>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormLabel>SMS Contact No.</CFormLabel>
                    <CFormInput
                      type="text"
                      id="studSmsContactNo"
                      name="studSmsContactNo"
                      placeholder="Enter contact number"
                      value={formData.studSmsContactNo}
                      onChange={(e) => onFormValueChange('studSmsContactNo', e.target.value)}
                    />
                  </CCol>

                  <CCol md={6}>
                    <CFormLabel>Email Address</CFormLabel>
                    <CFormInput
                      type="email"
                      id="studEmailAddress"
                      name="studEmailAddress"
                      placeholder="Enter email address"
                      value={formData.studEmailAddress}
                      onChange={(e) => onFormValueChange('studEmailAddress', e.target.value)}
                    />
                  </CCol>
                </CRow>
              </CCardBody>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CRow>
              <CCol className="d-flex justify-content-end gap-2">
                {!selectedAdmissionId && (
                  <CButton color="secondary" onClick={() => setFormData(initialFormData)}>
                    Reset
                  </CButton>
                )}
                {formData.isAdmitted != 'Yes' && (
                  <CButton color="primary" onClick={(e) => handleSubmit(e, true)}>
                    Save & Enroll
                  </CButton>
                )}
                <CButton
                  color="success "
                  className="text-white"
                  onClick={(e) => handleSubmit(e, false)}
                >
                  Save
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CForm>
      </CCard>

      <CModal
        size="xl"
        className="outer-modal"
        scrollable
        alignment="center"
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false)
        }}
      >
        <CModalHeader>Confirm Admission</CModalHeader>
        <CModalBody>
          {modalVisible && (
            <ConfirmAdmission confirmAdmissionId={reponseAdmissionId} onEnroll={handleEnroll} />
          )}
        </CModalBody>
      </CModal>
      {isLoading && <AppLoader />}
    </>
  )
}

StudentAdmission.propTypes = {
  selectedAdmissionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
